import { createContext } from "react";
import type SidebarContextType from "../types/contexts/SidebarContextType";

const SidebarContext = createContext<SidebarContextType | undefined>(undefined);

export default SidebarContext;
